











export default
  name: 'Modal'
  props: ['show', 'hideable', 'width']

  computed:
    maxWidth: ->
      max = @width or 'sm'
      "max-w-#{max}"

  methods: 
    closeModal: ->  @$emit('update:show', false) if @hideable
